import {QR_CODE_PRINT_SIDELENGTH} from "@/shared/constants";

interface PrintQrCodeOptions {
	qrCodeImageUrl: string;
	name: string;
	login: string;
	description: string;
}

export function printQrCode({qrCodeImageUrl, name, login, description}: PrintQrCodeOptions) {
	const frame = document.createElement("iframe");
	frame.setAttribute("aria-hidden", "true");
	frame.style.cssText = "position:fixed;width:0;height:0;border:0;";
	document.body.appendChild(frame);

	const frameDocument = frame.contentDocument;
	const frameWindow = frame.contentWindow;
	if (frameDocument == null || frameWindow == null) {
		frame.remove();
		return;
	}

	const image = frameDocument.createElement("img");
	image.src = qrCodeImageUrl;
	image.width = QR_CODE_PRINT_SIDELENGTH;
	image.height = QR_CODE_PRINT_SIDELENGTH;

	const heading = frameDocument.createElement("h1");
	heading.textContent = name;

	const loginLine = frameDocument.createElement("div");
	loginLine.textContent = login;

	const text = frameDocument.createElement("p");
	text.textContent = description;

	const caption = frameDocument.createElement("div");
	caption.append(heading, loginLine, text);

	const layout = frameDocument.createElement("div");
	layout.style.cssText = "display:flex;gap:20px;align-items:flex-start;font-size:11pt;";
	layout.append(image, caption);
	frameDocument.body.append(layout);

	frameWindow.addEventListener("afterprint", () => frame.remove());

	const print = () => {
		frameWindow.focus();
		frameWindow.print();
	};

	if (image.complete) {
		print();
	} else {
		/* printing before the QR image is decoded would produce a blank sheet */
		image.addEventListener("load", print);
		image.addEventListener("error", () => frame.remove());
	}
}
